import { render, staticRenderFns } from "./AddPinValidity.vue?vue&type=template&id=83b54704&scoped=true"
import script from "./AddPinValidity.vue?vue&type=script&lang=js"
export * from "./AddPinValidity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b54704",
  null
  
)

export default component.exports